import React, {useEffect, useState, useRef, useContext} from 'react';
import { Container, Row, Col, Table } from 'reactstrap';
import { getMentorships } from '../../../helpers/Mentorships.helper';
import { Solicitadas, Activas, Finalizadas } from './MisMentoriasTabs';
import GlobalContext from '../../../context/GlobalContext';
import classes from './MisMentorias.module.css';
import { acceptMentorship, cancelMentorship, finishMentorship } from '../../../helpers/Mentorships.helper';
import { getDate } from '../../../helpers/functions.helper';

const MisMentorias = () => {

    const [isHidden, setIsHidden] = useState(true);
    const [activeTab, setActiveTab] = useState(1);
    const [status, setStatus] = useState(0);

    const tab1 = useRef();
    const tab2 = useRef();
    const tab3 = useRef();
    const fecha_ref = useRef();
    const evaluacion_ref = useRef();
    const observaciones_ref = useRef();

    const [solicitadas, setSolicitadas] = useState([]);
    const [activas, setActivas] = useState([]);
    const [finalizadas, setFinalizadas] = useState([]);

    //states for hidden page
    const [subtitle, setSubtitle] = useState('');
    const [buttonText, setButtonText] = useState('');
    const [folio, setFolio] = useState(0);
    const [matricula, setMatricula] = useState('');
    const [alumno, setAlumno] = useState('');
    const [categoria, setCategoria] = useState('');
    const [mensaje, setMensaje] = useState('');
    const [fechaSolicitud, setFechaSolicitud] = useState('');
    const [evaluacion, setEvaluacion] = useState('');
    const [observaciones, setObservaciones] = useState('');
    
    const {mentorias, setMentorias, setLoading} = useContext(GlobalContext);

    useEffect(()=>{
        if(mentorias && mentorias.length == 0){
            setLoading(true);
            getMentorships().then(d => {
                setMentorias(d);
                orderMentorships(d);
                setLoading(false);
            }).catch(error => {
                console.error(error);
                setLoading(false);
            })
        }else{
            orderMentorships(mentorias);
        }
    },[]);

    useEffect(()=>{
        if(isHidden)
            handleTab(activeTab)
    }, [solicitadas, isHidden]);

    //OCULTAR/MOSTRAR INPUTS AL CAMBIAR ESTADO isHidden
    useEffect(()=>{
        if(!isHidden){
            if(status == 2 || status == 4){
                evaluacion_ref.current.classList.add('hidden');
                observaciones_ref.current.classList.add('hidden');
            }else{
                fecha_ref.current.classList.add('hidden');
            }
        }
    }, [isHidden, status]);

    const orderMentorships = (mentorships) => {
        if(mentorships.length > 0){
            let solicitadas = [],
                activas = [],
                finalizadas = [];
            mentorships.forEach(mentorship => {
                const status = mentorship.idStatus;
                if(status == 1)
                    solicitadas.push(mentorship);
                else if(status == 2)
                    activas.push(mentorship);
                else
                    finalizadas.push(mentorship);
            })
            setSolicitadas(solicitadas);
            setActivas(activas);
            setFinalizadas(finalizadas);
            return true;
        }
    }

    const handleTab = (tab) =>{
        const active = document.querySelectorAll('.active');
        active.forEach(item => {
            item.classList.remove('active');
        });
        switch(tab){
            case 1:
                tab1.current.classList.add('active');
                break;
            case 2:
                tab2.current.classList.add('active');
                break;
            case 3:
                tab3.current.classList.add('active');
                break;
            default:
                break;
        }
        setActiveTab(tab);
    }

    const handleClick = (data) => {
        setIsHidden(false);
        setStatus(data.estatus);

        setSubtitle(data.text + ' solicitud');
        setButtonText(data.text);
        setFolio(data.mentoria.iFolio);
        setMatricula(data.mentoria.iMatricula);
        setAlumno(data.mentoria.sNombreAlumno);
        setCategoria(data.mentoria.sCategoria);
        setMensaje(data.mentoria.sSolicitud);
        setFechaSolicitud(data.mentoria.dFecha);
        setEvaluacion(data.mentoria.iEvaluacionAlumno);
        setObservaciones(data.mentoria.sComentariosMentor);
    }

    const clearData = () => {
        setStatus(0);
        setSubtitle('');
        setButtonText('');
        setFolio(0);
        setMatricula('');
        setAlumno('');
        setCategoria('');
        setMensaje('');
        setFechaSolicitud('');
        setEvaluacion('');
        setObservaciones('');
    }

    const handleReturn = () => {
        setIsHidden(!isHidden);
        clearData();

        // document.getElementById('date').classList.remove('hidden');
        // document.getElementById('evaluacion').classList.remove('hidden');
        // document.getElementById('observaciones').classList.remove('hidden');
    }

    const handleSubmit = () => {
        if(status > 0){
            setLoading(true);
            const folio = parseInt(document.getElementById('folio').value);
            switch(status){
                case 2:
                    acceptMentorship(folio).then(data=>{
                        console.log(data);
                        window.location.reload();
                        setLoading(false);
                    }).catch(error=>{
                        console.error(error);
                        setLoading(false);
                    })
                    break;
                case 4:
                    cancelMentorship(folio).then(data=>{
                        console.log(data);
                        window.location.reload();
                        setLoading(false);
                    }).catch(error=>{
                        console.error(error);
                        setLoading(false);
                    })
                    break;
                default:
                    const observaciones = document.getElementById('observaciones').value;
                    const evaluacion = document.getElementById('evaluacion').value;

                    const data = {
                        folioId: folio,
                        problem: status,
                        sComentariosMentor: observaciones,
                        iEvaluacionAlumno: evaluacion
                    }

                    finishMentorship(data).then(data=>{
                        console.log(data);
                        window.location.reload();
                        setLoading(false);
                    }).catch(error=>{
                        console.error(error);
                        setLoading(false);
                    })
                    break;
            }
        }
    }

    return(
        <>
        {
            (isHidden)?
            <>
                <Container>
                    <Row>
                        <Col className="title-container">
                            <div>
                                <h1>Mis mentorías</h1>
                                <div className={classes.tabsContainer}>
                                    <span className={classes.tab} onClick={()=>{handleTab(1)}} ref={tab1}>{(solicitadas.length > 0) ? `Solicitudes (${solicitadas.length})`:'Solicitudes'}</span>
                                    |
                                    <span className={classes.tab} onClick={()=>{handleTab(2)}} ref={tab2}>Mis mentorías activas</span>
                                    |
                                    <span className={classes.tab} onClick={()=>{handleTab(3)}} ref={tab3}>Finalizadas</span>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
                {
                    (activeTab == 1)&&
                    <Solicitadas solicitadas={solicitadas} handleClick={handleClick} isHidden={setIsHidden}/>
                }
                {
                    (activeTab == 2)&&
                    <Activas activas={activas} handleClick={handleClick} isHidden={setIsHidden}/>
                }
                {
                    (activeTab == 3)&&
                    <Finalizadas finalizadas={finalizadas} handleClick={handleClick} isHidden={setIsHidden}/>
                }
            </>
            :
            <Container>
                <Row>
                    <Col className="title-container">
                        <div>
                            <h1>Solicitudes de mentoría</h1>
                            <div className={classes.tabsContainer}>
                                <span>{subtitle}</span>
                            </div>
                        </div>
                    </Col>
                </Row>
                <Container style={{marginBottom: '50px'}}>
                    <Row>
                        <Col>
                            <form>
                                
                                <div className={classes.flexContainer}>
                                    <div className={"input-container " + classes.inputContainer}>
                                        <label className={classes.text} htmlFor="folio">Folio</label>
                                        <input type="text" id="folio" className={classes.input} value={folio} readOnly={true}/>
                                    </div>
                                    <div className={"input-container " + classes.inputContainer}>
                                        <label className={classes.text} htmlFor="matricula">Matrícula</label>
                                        <input type="text" id="matricula" className={classes.input} value={matricula} readOnly={true}/>
                                    </div>
                                </div>

                                <div className={classes.flexContainer}>
                                    <div className={"input-container " + classes.inputContainer}>
                                        <label className={classes.text} htmlFor="alumno">Alumno</label>
                                        <input type="text" id="alumno" className={classes.input} value={alumno} readOnly={true}/>
                                    </div>
                                    <div className={"input-container " + classes.inputContainer}>
                                        <label className={classes.text} htmlFor="categoria">Categoría</label>
                                        <input type="text" id="categoria" className={classes.input} value={categoria} readOnly={true}/>
                                    </div>
                                </div>

                                <div className={classes.inputContainer}>
                                    <label className={classes.text} htmlFor="mensaje">El alumno te envió el siguiente mensaje</label>
                                    <textarea id="mensaje" className={classes.input} value={mensaje} readOnly={true}/>
                                </div>

                                <div className={classes.inputContainer} ref={fecha_ref}>
                                    <label className={classes.text} htmlFor="date">Fecha de solicitud</label>
                                    <input type="text" id="date" className={classes.input} value={getDate(fechaSolicitud)} readOnly={true}/>
                                </div>

                                <div className={classes.inputContainer} ref={evaluacion_ref}>
                                    <label className={classes.text} htmlFor="evaluacion">Evalúa a tu alumno</label>
                                    <select id='evaluacion' className={classes.input}>
                                        <option value="10">Excedió mis expectativas</option>
                                        <option value="8">Cumplió con mis expectativas</option>
                                        <option value="5">Estuvo por debajo de mis expectativas</option>
                                        <option value="0">Estuvo muy por debajo de mis expectativas</option>
                                    </select>
                                </div>

                                <div className={classes.inputContainer} ref={observaciones_ref}>
                                    <label className={classes.text} htmlFor="observaciones">Observaciones generales de la mentoría</label>
                                    <textarea id="observaciones" className={classes.input} value={observaciones}/>
                                </div>

                                <div className={classes.saveButtons}>
                                    <input type="button" className={classes.button} value={buttonText} onClick={handleSubmit}/>
                                    <span className={classes.regresar} onClick={handleReturn}>Regresar a mis solicitudes</span>
                                </div>
                            </form>
                        </Col>
                    </Row>
                </Container>
            </Container>
        }
        </>
    )
}
export default MisMentorias;